import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { unwrapResult } from "@reduxjs/toolkit";
import { validator } from "../../Js/Validator";
import { useNavigate } from "react-router-dom";

import "../Installation/InstallationLayout.css";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import AccountCircle from "@mui/icons-material/AccountCircle";
import LockIcon from "@mui/icons-material/Lock";

import {
  Grid,
  Box,
  Typography,
  TextField,
  Button,
  Link,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import Snackbar from "@mui/material/Snackbar";

import Confirmation from "../../Components/Modal/Confirmation";
import LoginHeader from "../../Components/UI/LoginHeader";
import LoginFooter from "../../Components/UI/LoginFooter";

import {
  authenticate,
  getOfflineGraceExtend,
  getCustomerGraceRequest,
  getProductLicenseRenew,
} from "./Services";
import { loggedInUserInfoSliceActions } from "../../Store/Slices/LoggedInUserInfo";
import {
  fetchSiteConfig,
  fetchServerEnv,
  defsSliceActions,
} from "../../Store/Slices/DefsSlice";
import {
  addLicenseExpiry,
  checkProductExpiry,
  checkExpiryProductWithFlag,
} from "../../Js/CheckProductExpiry";
import {
  userLogs,
  getDefsByKeyId,
  getUserLogs,
  checkInternet,
  updateDefs,
} from "../../Js/Common";
import { commonSliceActions } from "../../Store/Slices/CommonSlice";
import { installationSliceActions } from "../../Store/Slices/InstallationSlice";
import _ from "lodash";

const Login = (props) => {
  // Hooks
  const navigation = useNavigate();
  const dispatch = useDispatch();
  const classes = useStyles();

  // State
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [validate, setValidate] = useState(false);
  const [passwordVisibility, setPasswordVisibility] = useState(false);
  const [usernameError, setUsernameError] = useState(null);
  const [passwordError, setPasswordError] = useState(null);
  const [modalVisible, setModalVisible] = useState(false);
  const [alertMsg, setAlertMsg] = useState(null);

  const [authResponseData, setAuthResponseData] = useState(null);
  const [expiredProducts, setExpiredProducts] = useState([]);
  const [expiredProductsData, setExpiredProductsData] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [selectedProductData, setSelectedProductData] = useState(null);

  const [errorMsg, setErrorMsg] = useState(null);

  const [showGraceTimeBtnDiv, setShowGraceTimeBtnDiv] = useState(false);
  const [showGraceTimeBtn, setShowGraceTimeBtn] = useState(false);
  const [showGraceTimeBtnDisable, setShowGraceTimeBtnDisable] = useState(false);
  const [showRenewBtn, setShowRenewBtn] = useState(false);
  const [instituteLogo, setInstituteLogo] = useState(null);

  const [stateSnackbar, setStateSnackbar] = useState({
    modalopen: false,
    vertical: "bottom",
    horizontal: "center",
    snackbarMessage: "",
  });
  const { vertical, horizontal, modalopen, snackbarMessage } = stateSnackbar;
  const [isColorFlag, setIsColorFlag] = useState(false);
  const [defs, setDefs] = useState(null);

  // Redux state
  const { siteConfig, defsCreatedAt, serverRole } = useSelector(
    (state) => state.defs
  );
  const { whoAmIData } = useSelector((state) => state.installation);

  // Fetch & set server role default page
  useEffect(() => {
    //console.log("serverRole****************");
    dispatch(
      fetchServerEnv({
        envName: "SERVER_ROLE",
      })
    );
    console.log("serverRole", serverRole);
  }, []);

  useEffect(() => {
    let port = sessionStorage.getItem("port_data")
      ? sessionStorage.getItem("port_data").split(",")
      : process.env.REACT_APP_PORT_DATA.split(",");
    let url = sessionStorage.getItem("site_ip")
      ? `${sessionStorage.getItem("site_ip")}:${port[0]}`
      : `${process.env.REACT_APP_SERVER_API}:${port[0]}`;
    if (siteConfig?.customer?.logo) {
      setInstituteLogo(`${url}/branding_media/${siteConfig?.customer?.logo}`);
    } else {
      setInstituteLogo(null);
    }
  }, [siteConfig]);

  useEffect(() => {
    if (serverRole == null && serverRole != "WEB_HOST") {
      console.log("HERERE", whoAmIData);
      if (whoAmIData && whoAmIData.customer_uuid) {
        dispatch(
          fetchSiteConfig({
            keyid: "site_config",
            site_uuid: whoAmIData.customer_uuid,
          })
        );
        console.log("siteConfig", siteConfig);
      }
      console.log("siteConfig5454", siteConfig);
    }
  }, [serverRole]);

  // On blur get school name to display on top
  const getDefsFromAlias = () => {
    if (serverRole && serverRole == "WEB_HOST") {
      if (!username.includes("@")) {
        setUsernameError("Incorrect username!");
        setValidate(false);
        dispatch(commonSliceActions.setLoader(false));
        return false;
      }

      let alias = username.split("@");
      if (alias[alias.length - 1].trim().length == 0) {
        setUsernameError("Alias is missing!");
        setValidate(false);
        dispatch(commonSliceActions.setLoader(false));
        return false;
      }

      dispatch(
        fetchSiteConfig({
          keyid: "site_config",
          keydata: {
            customer: {
              licenceAlias: alias[alias.length - 1].toUpperCase().trim(),
            },
          },
        })
      );
    }
  };

  // Validate username on blur
  const usernameBlurValidate = () => {
    let validate = validator({ required: true, value: username });
    if (!validate["validate"]) {
      setUsernameError(validate["message"]);
      setValidate(false);
      dispatch(commonSliceActions.setLoader(false));
    } else {
      setUsernameError(null);
      setValidate(true);
      getDefsFromAlias();
    }
  };

  // Validate password on blur
  const passwordBlurValidate = () => {
    let validate = validator({ required: true, value: password });
    if (!validate["validate"]) {
      setPasswordError(validate["message"]);
      setValidate(false);
      dispatch(commonSliceActions.setLoader(false));
    } else {
      setPasswordError(null);
      setValidate(true);
      getDefsFromAlias();
    }
  };

  // Validate credentials on login click & redirect to respective dashboard
  const validateCredentials = async () => {
    usernameBlurValidate();
    passwordBlurValidate();
    if (!sessionStorage.getItem("media_url")) {
      sessionStorage.setItem("media_url", process.env.REACT_APP_ASSET_MEDIA);
    }
    if (validate) {
      dispatch(commonSliceActions.setLoader(true));
      let usrNm = username;
      console.log("username.split", username.split("@"));

      if (serverRole == null && serverRole !== "WEB_HOST") {
        usrNm =
          username.toLowerCase() +
          "@" +
          siteConfig.customer.licenceAlias.toLowerCase();
      }
      console.log("usrNm", usrNm);
      let authResponse = await authenticate(usrNm, password);
      if (authResponse.code === 404 || authResponse.code === 401) {
        setAlertMsg("Incorrect Credentials!");
        setModalVisible(true);
        dispatch(commonSliceActions.setLoader(false));
      } else {
        setAuthResponseData(authResponse);

        let checkInternalVal = await checkInternalValidation(authResponse);
        dispatch(commonSliceActions.setLoader(false));
        if (checkInternalVal) {
          doLoginData(authResponse);
        }
      }
    }
  };

  const checkInternalValidation = async (authResponse) => {
    // console.log("authResponse.userInfo", authResponse);
    if (authResponse.userInfo.status === false) {
      setAlertMsg("User is inactive!");
      setModalVisible(true);
      resetAppData();
      return false;
    }

    let siteConfig1;

    if (siteConfig && Object.keys(siteConfig).length > 0) {
      siteConfig1 = JSON.parse(JSON.stringify(siteConfig));
    } else {
      let alias = username.split("@");

      siteConfig1 = await dispatch(
        fetchSiteConfig({
          keyid: "site_config",
          keydata: {
            customer: {
              licenceAlias: alias[alias.length - 1].toUpperCase().trim(),
            },
          },
        })
      );
      siteConfig1 = unwrapResult(siteConfig1);
      siteConfig1 = siteConfig1.keydata;
      siteConfig1 = JSON.parse(JSON.stringify(siteConfig1));
    }
    let role_title = authResponse.userInfo.rolesInfo.title.toLowerCase();
    if (serverRole && serverRole == "WEB_HOST") {
      let customerData = siteConfig1.customer;
      // console.log("customerData=====>", customerData);
      if (customerData && customerData.hasOwnProperty("syncData")) {
        if (
          customerData.syncData.isSync === true &&
          customerData.syncData.isWebLogin === false &&
          role_title !== "incharge" &&
          role_title !== "admin"
        ) {
          setAlertMsg(
            "You do not have access for online usage. Please contact your administrator!"
          );
          setModalVisible(true);
          resetAppData();
          return false;
        }
      }
      if (
        role_title === "learner" &&
        authResponse.userInfo.allowedweblogin === false
      ) {
        setAlertMsg("Usage restricted. Please contact your administrator!");
        setModalVisible(true);
        resetAppData();
        return false;
      }
    }

    // It adds licnese expiry object if it is not in product
    await addLicenseExpiry(siteConfig1, defsCreatedAt);

    let diff = await checkProductExpiry(siteConfig1);

    console.log("diffffffffff", diff);
    if (diff < 0) {
      if (role_title != "learner") {
        setErrorMsg(
          "The validity of your product has expired. Please contact your administrator for assistance."
        );
        setShowGraceTimeBtn(true);
        let products = siteConfig1.products;
        let productwiseMaxStatus = [];
        let dbExpiredProducts = [];
        let dbExpiredProductsData = [];
        console.log("products====>", products);

        for (let i = 0; i < products.length; i++) {
          let resObj = await checkExpiryProductWithFlag(
            siteConfig1,
            products[i]["productId"]
          );
          // console.log("resObj======>", resObj);

          if (resObj.difference <= 0) {
            dbExpiredProducts.push({
              label: products[i]["productName"],
              value: products[i]["productId"],
            });

            products[i]["licenseExpiry"] = [];
            products[i]["licenseExpiry"].push(resObj.activeLicenseObj);

            dbExpiredProductsData.push(products[i]);
            productwiseMaxStatus.push({
              productId: products[i]["productId"],
              maxId: 0,
              status: null,
            });
          }
          console.log("HHHHHHHHHHRRRRRRRREEEEEEEEE", resObj);
        }

        // console.log(productwiseMaxStatus);
        // console.log(dbExpiredProducts);
        // console.log(dbExpiredProductsData);

        let expireProdCount = dbExpiredProductsData.length;
        let productIds = _.map(dbExpiredProducts, "value");

        let params = {
          query: {
            verb: "sendRequestForGraceTime",
            target: productIds,
            site_uuid: authResponse.userInfo.site_uuid,
          },
        };
        let logsOfRequest = await getUserLogs(params);
        logsOfRequest = logsOfRequest.data;
        // console.log("%%%^^^", logsOfRequest);

        let sortedData = _.sortBy(logsOfRequest.data, ["id"]);
        logsOfRequest.data = sortedData;

        if (logsOfRequest.data.length > 0) {
          for (let x = 0; x < logsOfRequest.data.length; x++) {
            let indx = _.findIndex(productwiseMaxStatus, {
              productId: logsOfRequest.data[x]["target"],
            });
            productwiseMaxStatus[indx]["maxId"] = logsOfRequest.data[x]["id"];
            productwiseMaxStatus[indx]["status"] =
              logsOfRequest.data[x]["context"]["request_status"];
            productwiseMaxStatus[indx]["uuid_of_request"] =
              logsOfRequest.data[x]["context"]["uuid"];
          }

          for (let j = 0; j < productwiseMaxStatus.length; j++) {
            // console.log("productwiseMaxStatus[j]['status']", productwiseMaxStatus[j]['status']);
            if (
              productwiseMaxStatus[j]["status"] == "pending" ||
              productwiseMaxStatus[j]["status"] == "approved"
            ) {
              if (productwiseMaxStatus[j]["status"] == "pending") {
                let gracePrams = {
                  query: {
                    productId: productwiseMaxStatus[j]["productId"],
                    requestId: productwiseMaxStatus[j]["uuid_of_request"],
                    site_uuid: authResponse.userInfo.site_uuid,
                  },
                };
                let res = await getOfflineGraceExtend(gracePrams);
                // console.log("%%%%%&&&***", res);
                if (res == "noInternet") {
                  setIsColorFlag(false);
                  setStateSnackbar({
                    ...stateSnackbar,
                    modalopen: true,
                    snackbarMessage: "Internet connection required on server",
                  });
                  break;
                } else if (res == "updated") {
                  // this.dologin(u, p);
                  dispatch(
                    fetchSiteConfig({
                      keyid: "site_config",
                      site_uuid: authResponse.userInfo.site_uuid,
                    })
                  );
                  return true;
                }
              }
              if (
                dbExpiredProductsData.length > 1 ||
                productwiseMaxStatus[j]["status"] == "pending"
              ) {
                let indx = _.findIndex(dbExpiredProductsData, {
                  productId: productwiseMaxStatus[j]["productId"],
                });
                dbExpiredProductsData.splice(indx, 1);
                let indx1 = _.findIndex(dbExpiredProducts, {
                  value: productwiseMaxStatus[j]["productId"],
                });
                dbExpiredProducts.splice(indx1, 1);
              }
            }
          } //end for loop
        }
        // console.log("^^77", dbExpiredProducts, expireProdCount);

        setExpiredProducts(dbExpiredProducts);
        setExpiredProductsData(dbExpiredProductsData);

        if (expireProdCount != 0 && dbExpiredProductsData.length == 0) {
          //showGraceTimeBtn = true;
          //showGraceTimeBtnDisable = true;

          setShowGraceTimeBtn(true);
          setShowGraceTimeBtnDisable(true);
        } else {
          //showGraceTimeBtnDisable = false;
          setShowGraceTimeBtnDisable(false);
          setSelectedProduct(dbExpiredProductsData[0]["productId"]);
          setSelectedProductData(dbExpiredProductsData[0]);

          let resObj1 = await checkExpiryProductWithFlag(
            siteConfig1,
            products[0]["productId"]
          );
          // console.log("%%%%%%", resObj1);

          if (resObj1.expiryType == "grace_period") {
            //showGraceTimeBtn=true;
            //showRenewBtn=false;
            setShowGraceTimeBtn(true);
            setShowRenewBtn(false);
          } else {
            //showRenewBtn = true;
            //showGraceTimeBtn = false;
            setShowRenewBtn(true);
            setShowGraceTimeBtn(false);
          }
          // console.log("RRRRR", dbExpiredProducts);
        }
      } else {
        setErrorMsg("Unable to Login! Please contact your administrator.");
        setShowGraceTimeBtn(false);
      }
      setShowGraceTimeBtnDiv(true);
      return false;
    } else {
      return true;
    }
  };

  const changeProduct = async (productId) => {
    let dbSelectedProductData = _.find(expiredProductsData, {
      productId: productId,
    });
    console.log("^&&&&", productId);

    let siteConfig1 = JSON.parse(JSON.stringify(siteConfig));

    let resObj1 = await checkExpiryProductWithFlag(siteConfig1, productId);
    console.log("%%%%%%", resObj1);

    if (resObj1.expiryType == "grace_period") {
      // this.showGraceTimeBtn = true;
      // this.showRenewBtn = false;
      setShowGraceTimeBtn(true);
      setShowRenewBtn(false);
    } else {
      // this.showRenewBtn = true;
      // this.showGraceTimeBtn = false;
      setShowRenewBtn(true);
      setShowGraceTimeBtn(false);
    }
    console.log("$$$", dbSelectedProductData);
    setSelectedProductData(dbSelectedProductData);
  };

  const sendGraceRequest = async () => {
    if (serverRole == null || serverRole.toLowerCase() != "web_host") {
      let internetAvailability = await checkInternet();
      if (
        internetAvailability.internet == false ||
        internetAvailability.internet == "false"
      ) {
        setIsColorFlag(false);
        setStateSnackbar({
          ...stateSnackbar,
          modalopen: true,
          snackbarMessage: "Internet connection required on server",
        });
        return false;
      }
    }
    let installationType;
    if (serverRole == null || serverRole.toLowerCase() != "web_host") {
      installationType = "on_premise";
    } else {
      installationType = "on_webhost";
    }

    console.log(serverRole, installationType);

    let params = {
      query: {
        customer_uuid: authResponseData.userInfo.site_uuid,
        request_info: selectedProductData,
        grace_period: 0,
        request_for: installationType,
        request_from: "api",
      },
    };

    let graceData = await getCustomerGraceRequest(params);
    graceData = graceData.response;
    console.log("graceData=====>", graceData);

    if (graceData.status == "201" || graceData.status == 201) {
      delete graceData.data.request_info;
      let dataLogs = {
        actor: authResponseData.userInfo.uid,
        verb: "sendRequestForGraceTime",
        target: selectedProduct,
        context: graceData.data,
        site_uuid: authResponseData.userInfo.site_uuid,
      };
      await userLogs(dataLogs);
      // console.log("authResponseData=====>",authResponseData);
      setShowGraceTimeBtnDisable(true);
    }
  };

  const doLoginData = (authResponse) => {
    dispatch(
      loggedInUserInfoSliceActions.setAccessToken(
        localStorage.getItem("feathers-jwt")
      )
    );
    dispatch(loggedInUserInfoSliceActions.setAbilities(authResponse.abilities));
    dispatch(loggedInUserInfoSliceActions.setUserInfo(authResponse.userInfo));
    dispatch(
      loggedInUserInfoSliceActions.setUserPermission(
        authResponse.userPermission
      )
    );
    resetState();
    dispatch(commonSliceActions.setLoader(false));

    if (authResponse.userInfo.rolesInfo.title.toLowerCase() == "trainer") {
      navigation("/Teach");
    } else if (
      authResponse.userInfo.rolesInfo.title.toLowerCase() == "learner"
    ) {
      navigation("/Assignment");
    } else if (
      authResponse.userInfo.rolesInfo.title.toLowerCase() == "incharge"
    ) {
      navigation("/Dashboard");
    } else if (authResponse.userInfo.rolesInfo.title.toLowerCase() == "admin") {
      navigation("/Dashboard");
    } else if (authResponse.userInfo.rolesInfo.title.toLowerCase() == "staff") {
      navigation("/Report");
    } else if (
      authResponse.userInfo.rolesInfo.title.toLowerCase() == "broadcast"
    ) {
      navigation("/Podcast");
    }
    return;
  };

  const checkAmcRenewal = async () => {
    // console.log("checkRenewal selectedProduct", selectedProduct);
    let params = {
      query: {
        site_uuid: authResponseData.userInfo.site_uuid,
        productId: selectedProduct,
      },
    };
    let res = await getProductLicenseRenew(params);
    // console.log("%%%%%", res);

    let resSiteConfig = await getDefsByKeyId(
      "site_config",
      authResponseData.userInfo.site_uuid
    );
    //console.log("resSiteConfig",resSiteConfig);

    let siteConfig1 = resSiteConfig.data.keydata;
    // console.log("%% fetchSiteConfig %%%", siteConfig1);

    let products = siteConfig1.products;
    let indx = _.findIndex(products, { productId: selectedProduct });
    let resObj = await checkExpiryProductWithFlag(siteConfig1, selectedProduct);
    products[indx]["expiryDate"] = resObj.activeLicenseObj.valid_till;
    siteConfig1.products = products;

    let newData = {};
    newData.keyid = "site_config";
    newData.keydata = siteConfig1;
    newData.is_synced = false;

    let updateParams = {
      query: {
        keyid: "site_config",
        site_uuid: authResponseData.userInfo.site_uuid,
      },
    };
    await updateDefs(newData, updateParams);
    if (res.response.status == 200 || res.response.status == "200") {
      localStorage.removeItem("feathers-jwt");
      resetAppData();
      return false;
    }
  };

  // Reset all states on successful login
  const resetState = () => {
    setUsername("");
    setPassword("");
    setUsernameError(null);
    setPasswordError(null);
    setValidate(true);
    setModalVisible(false);
    setAlertMsg(null);

    setErrorMsg(false);
    setShowGraceTimeBtnDiv(false);
    setShowGraceTimeBtn(false);
    setShowGraceTimeBtnDisable(false);
    setShowRenewBtn(false);
  };

  const handleClickShowPassword = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleClose = () => {
    setStateSnackbar({
      ...stateSnackbar,
      modalopen: false,
      snackbarMessage: "",
    });
  };

  const resetAppData = () => {
    let serverData = serverRole;
    let whoAmIFileData = whoAmIData;
    setTimeout(() => {
      resetState();
      dispatch({ type: "RESET_APP" });
      dispatch(defsSliceActions.setServerRole(serverData));
      dispatch(installationSliceActions.setWhoAmIData(whoAmIFileData));
    }, 1000);
    return;
  };

  return (
    <Grid
      container
      spacing={1}
      className="full-height"
      sx={{ alignItems: "center" }}
    >
      <Grid item sm={12} md={6}>
        <Box
          sx={{
            bgcolor: "#DB8829",
            color: "primary.contrastText",
            display: { xs: "none", sm: "none", md: "block" },
          }}
          className="full-height"
        >
          <img
            src={require("../../assets/VocabLogin_White.png")}
            width="100%"
            alt="Vocablab"
          ></img>
        </Box>
      </Grid>
      <Grid item sm={12} md={6}>
        <Box sx={{ p: 1, textAlign: "center" }}>
          <LoginHeader
            instituteLogo={instituteLogo}
            primaryText={
              !siteConfig || !siteConfig.schoolName
                ? "School Name"
                : siteConfig.schoolName
            }
            secondaryText="Enter your Username and Password"
          ></LoginHeader>
          <Box>
            {/* {validateErrorMessage != null && (
              <Box sx={{ pt: 5, px: 10, textAlign: "center" }}>
                <Alert variant="filled" severity="error">
                  {validateErrorMessage}
                </Alert>
              </Box>
            )} */}
            {!showGraceTimeBtnDiv && (
              <>
                <Box sx={{ pt: 5, px: 10, textAlign: "center" }}>
                  <TextField
                    id="username"
                    name="userpass"
                    tabIndex={0}
                    placeholder="Username"
                    variant="outlined"
                    fullWidth
                    onBlur={() => {
                      usernameBlurValidate();
                    }}
                    onInput={(event) => {
                      setUsername(event.target.value.trim());
                    }}
                    InputProps={{
                      inputProps: { style: { padding: 10 } },
                      style: { borderRadius: 30 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <AccountCircle
                            sx={{
                              color: "#DB8829",
                              "@media (min-width: 1636px)": {
                                fontSize: "2rem",
                              },
                            }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment:
                        serverRole == null &&
                        siteConfig &&
                        siteConfig.customer ? (
                          <InputAdornment
                            position="end"
                            sx={{ color: "#DB8829" }}
                          >
                            @{siteConfig.customer.licenceAlias.toLowerCase()}
                          </InputAdornment>
                        ) : (
                          <></>
                        ),
                      sx: {
                        fontSize: "0.9rem",
                        color: "#DB8829",
                        fontWeight: "500",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                      },
                    }}
                    value={username}
                    helperText={usernameError}
                    error={usernameError != null}
                    onKeyDown={(event) => {
                      if (event.keyCode === 13) {
                        validateCredentials();
                      }
                    }}
                  />
                </Box>
                <Box sx={{ pt: 4, px: 10, textAlign: "left" }}>
                  <TextField
                    id="password"
                    name="userpass"
                    tabIndex={1}
                    placeholder="Password"
                    variant="outlined"
                    fullWidth
                    type={passwordVisibility ? "text" : "password"}
                    onInput={(event) => {
                      setPassword(event.target.value);
                    }}
                    value={password}
                    onBlur={() => {
                      passwordBlurValidate();
                    }}
                    InputProps={{
                      inputProps: { style: { padding: 10 } },
                      style: { borderRadius: 30 },
                      startAdornment: (
                        <InputAdornment position="start">
                          <LockIcon
                            sx={{
                              color: "#DB8829",
                              "@media (min-width: 1636px)": {
                                fontSize: "2rem",
                              },
                            }}
                          />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={handleClickShowPassword}
                            onMouseDown={handleMouseDownPassword}
                            edge="end"
                          >
                            {passwordVisibility ? (
                              <VisibilityOff />
                            ) : (
                              <Visibility
                                sx={{
                                  color: "#DB8829",
                                  "@media (min-width: 1636px)": {
                                    fontSize: "2rem",
                                  },
                                }}
                              />
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                      sx: {
                        fontSize: "0.9rem",
                        color: "#DB8829",
                        fontWeight: "500",
                        "@media (min-width: 1636px)": {
                          fontSize: "1.4rem",
                        },
                      },
                    }}
                    helperText={passwordError}
                    error={passwordError != null}
                    onKeyDown={(event) => {
                      if (event.keyCode === 13) {
                        validateCredentials();
                      }
                    }}
                  />
                  {/* <Typography sx={{ textAlign: "right", pr: 2 }}>
                    <Link
                      underline="none"
                      component="button"
                      sx={{
                        cursor: "pointer",
                        fontSize: "0.8em",
                        fontWeight: "500",
                        color: "#A9A9A9",
                        '@media (min-width: 1636px)': {
                          fontSize: '1.2rem'
                        }
                      }}
                      onClick={() => {
                        navigation('/RecoverPassword')
                      }}
                    >
                      {"Forgot Password?"}
                    </Link>
                  </Typography> */}
                </Box>
                <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
                  <Button
                    variant="contained"
                    tabIndex={2}
                    fullWidth
                    onClick={validateCredentials}
                    sx={{
                      backgroundColor:"#DB8829",
                      borderRadius: 20,
                      fontWeight: "600",
                      "@media (min-width: 1636px)": {
                        fontSize: "1.2rem",
                      },
                    }}
                    id="login"
                  >
                    {" "}
                    Sign In{" "}
                  </Button>
                </Box>
                {process.env.REACT_APP_FOR_IPAD == 'false' && (
                  <Grid
                    container
                    sx={{
                      flexDirection: "row",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Grid>
                      <Typography
                        sx={{
                          color: "#A9A9A9",
                          display: "inline-flex",
                          fontSize: "0.9em",
                          fontWeight: "600",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                          },
                        }}
                      >
                        Don't have an account?
                      </Typography>
                    </Grid>
                    <Grid>
                      <Button
                        fullWidth
                        sx={{
                          borderRadius: 20,
                          fontWeight: "600",
                          textTransform: "inherit",
                          "@media (min-width: 1636px)": {
                            fontSize: "1.2rem",
                          },
                        }}
                        onClick={() => {
                          navigation("/NewUserPasscodeValidate");
                        }}
                      >
                        Sign up
                      </Button>
                    </Grid>
                  </Grid>
                )}
              </>
            )}
            {showGraceTimeBtnDiv && (
              <>
                <Box sx={{ pt: 2, px: 10, textAlign: "center" }}>
                  <Typography>{errorMsg}</Typography>
                  {serverRole == null ||
                    (serverRole.toLowerCase() != "web_host" && (
                      <Typography>
                        NOTE : Internet connectivity required to send a request{" "}
                      </Typography>
                    ))}
                  {showGraceTimeBtnDisable == true &&
                    authResponseData.userInfo.rolesInfo.title.toLowerCase() !=
                      "learner" && (
                      <Typography>
                        You have already applied for grace extension. Please
                        wait for a response from our team.
                      </Typography>
                    )}

                  {showGraceTimeBtn && (
                    <Button
                      variant="contained"
                      tabIndex={2}
                      fullWidth
                      onClick={() => {
                        sendGraceRequest();
                      }}
                      disabled={showGraceTimeBtnDisable}
                      sx={{ borderRadius: 20, fontWeight: "600" }}
                    >
                      {"Request for grace time extension"}
                    </Button>
                  )}
                  {showRenewBtn && (
                    <Button
                      variant="contained"
                      tabIndex={2}
                      fullWidth
                      onClick={() => {
                        checkAmcRenewal();
                      }}
                      sx={{ mt: 1, borderRadius: 20, fontWeight: "600" }}
                    >
                      {"Check AMC Renewal"}
                    </Button>
                  )}
                </Box>
              </>
            )}
            {/* <LoginFooter></LoginFooter> */}
          </Box>
          <Confirmation
            visible={modalVisible}
            primaryText={alertMsg}
            image="error"
            alert={true}
            toggleModal={(flag) => setModalVisible(flag)}
            timeout={3000}
          ></Confirmation>
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            autoHideDuration={2000}
            open={modalopen}
            onClose={handleClose}
            message={snackbarMessage}
            key={vertical + horizontal}
            ContentProps={{
              classes: {
                root: isColorFlag ? classes.rootColor : classes.rootColor1,
              },
            }}
            sx={{ top: { xs: 90, sm: 0 } }}
          />
        </Box>
      </Grid>
    </Grid>
  );
};
const useStyles = makeStyles({
  rootColor: {
    backgroundColor: "lightgreen",
    color: "black",
  },
  rootColor1: {
    backgroundColor: "orange",
    color: "black",
  },
});
export default Login;
